import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getProjectStats = (
    token: string,
    backend: string,
) => {
    return fetch(
        `${getApiUrl(backend)}project_stats`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json, text/plain, */*'
            },
        }
    );
};

export default getProjectStats;
